<template>
  <v-dialog v-model="show" max-width="820px" dark persistent scrollable>
    <v-card dark>
      <v-card-title class="text-h6">
        Copy Layout
        <v-spacer />
        <v-btn icon :disabled="saving" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pa-4">
        <v-alert v-if="allMatched" type="success" dense outlined class="mb-4">
          Success, all products matched
        </v-alert>
        <v-alert v-else type="warning" dense outlined class="mb-4">
          Some layout products could not be matched by Product Name. Remap them
          or remove them from the copied layout.
        </v-alert>

        <div v-if="(result.Matched || []).length" class="mb-4">
          <div class="text-subtitle-2 mb-2">Matched</div>
          <ul class="mb-0">
            <li v-for="item in result.Matched" :key="item.SourceProductId">
              {{ item.SourceProductName }} → {{ item.DestProductName }}
            </li>
          </ul>
        </div>

        <div v-if="unmatchedRows.length">
          <div class="text-subtitle-2 mb-2">Unmatched</div>
          <div
            v-for="row in unmatchedRows"
            :key="row.SourceProductId"
            class="d-flex align-center mb-3"
          >
            <div class="flex-grow-1 mr-3">{{ row.SourceProductName }}</div>
            <v-select
              v-model="row.destProductId"
              :items="destProductItems"
              item-text="ProductName"
              item-value="ProductId"
              dense
              outlined
              hide-details
              clearable
              label="Destination product"
              class="flex-grow-1"
              :disabled="saving || row.remove"
            />
            <v-checkbox
              v-model="row.remove"
              class="ml-3 mt-0"
              hide-details
              label="Remove"
              :disabled="saving"
            />
          </div>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text :disabled="saving" @click="close">Cancel</v-btn>
        <v-btn
          color="primary"
          :loading="saving"
          :disabled="!canSave"
          @click="save"
        >
          Save Layout
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "LayoutCopyMatchDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Object,
      default: () => ({}),
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      unmatchedRows: [],
    };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    allMatched() {
      return Boolean(this.result && this.result.AllMatched);
    },

    destProductItems() {
      return this.result.DestProducts || [];
    },

    canSave() {
      if (this.saving) return false;
      return this.unmatchedRows.every(
        (row) => row.remove || !!row.destProductId
      );
    },
  },

  watch: {
    value(open) {
      if (open) this.syncRows();
    },
    result: {
      handler() {
        if (this.value) this.syncRows();
      },
      deep: true,
    },
  },

  methods: {
    syncRows() {
      this.unmatchedRows = (this.result.Unmatched || []).map((item) => ({
        SourceProductId: item.SourceProductId,
        SourceProductName: item.SourceProductName,
        destProductId: null,
        remove: false,
      }));
    },

    close() {
      if (this.saving) return;
      this.show = false;
    },

    save() {
      if (!this.canSave) return;
      const remaps = {};
      (this.result.Matched || []).forEach((item) => {
        remaps[item.SourceProductId] = item.DestProductId;
      });
      const removeProductIds = [];
      this.unmatchedRows.forEach((row) => {
        if (row.remove) {
          removeProductIds.push(row.SourceProductId);
        } else if (row.destProductId) {
          remaps[row.SourceProductId] = row.destProductId;
        }
      });
      this.$emit("save", { remaps, removeProductIds });
    },
  },
};
</script>
